module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/plan03_point-ede4dda764e6dad83dcedc2e2a5474ab.jpg";